import React, { useState, useEffect, useRef } from 'react';

import Header from './Header';
import Footer from './Footer';
import EmbedHide from './EmbedHide';
import Error404 from '../../../Pages/Error404';
import { useHistory } from 'react-router';
import PathsConfig from '../../../Config/RoutePaths';

const NotFoundLayout = ({setNoMatch}) => {
    const history = useHistory();
    const handleClickButton = () => {
        setNoMatch(false)
        history.push({
            pathname: PathsConfig.HomeMyAccount,
        });
    }
    return (
        <div>
            <EmbedHide>
                <Header 
                />
            </EmbedHide> 
            <main className="menu__main">
                    <Error404 handleClickButton={handleClickButton}/>
                </main>
            <EmbedHide>  
                <Footer />
            </EmbedHide>  
        </div>
    );
};

export default NotFoundLayout;